import React, { useState } from "react";
import CreatableSelect from "react-select/lib/Creatable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../../revvComponents";

const AddNewField = ({ fieldList, handleAddNewField, fieldMapping }) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    label: "Search...",
    sublabel: "",
    value: "",
  });

  const _handleOptionChange = event => {
    // add to list , then remove dropdown active + set initial state
    setSelectedOption(event);
    handleAddNewField(event.id || event.name, fieldMapping, event.sub_field);
    setDropdownActive(!dropdownActive);
  };

  const _handleFieldsList = fieldsList => {
    fieldsList = fieldsList.map(field => {
      if (!field.value) {
        field.value = field.label;
      }
      return field;
    });
    return fieldsList;
  };

  return (
    <div className="add-new-field">
      <Button
        data-test="add-new-field-btn"
        className="sf-add-new-field-btn"
        onClick={() => setDropdownActive(!dropdownActive)}>
        <FontAwesomeIcon
          icon={["far", "plus"]}
          className="sf-add-new-field-icon"
        />
      </Button>{" "}
      {dropdownActive ? (
        <div className="add-new-field-dropdown">
          <CreatableSelect
            isSearchable
            style={{
              height: "25px",
            }}
            isDisabled={false}
            options={_handleFieldsList(fieldList)}
            value={selectedOption}
            onChange={_handleOptionChange}
            autoFocus
            openMenuOnFocus
            formatCreateLabel={() => undefined}
            onBlur={() => {
              setDropdownActive(!dropdownActive);
            }}
            data-test="sf-objects-select"
          />
        </div>
      ) : (
        <span
          onKeyDown={() => {}}
          tabIndex="0"
          role="button"
          onClick={() => setDropdownActive(!dropdownActive)}>
          Click to add field
        </span>
      )}
    </div>
  );
};

export default AddNewField;
